import apiClient from './api';

const billMultiple = (data) => {
  return apiClient.post('/billing/multiple', data).then((res) => res.data);
};

const billSingle = (data) => {
  return apiClient.post('/billing/single', data).then((res) => res.data);
};

const cancellInvoice = (id) => {
  return apiClient.get('/billing/cancel/' + id).then((res) => res.data);
};

const exportExcel = (filters) => {
  return apiClient
    .get('/billing/invoices/export-excel', {
      responseType: 'arraybuffer',
      params: filters,
    })
    .then((res) => res.data);
};

const exportConcar = async (filters) => {
  const response = await apiClient.get('/billing/invoices/export-concar', {
    params: filters,
    responseType: 'blob',
    withCredentials: true,
  });

  return response.data;
};

const exportDbf = async (filters) => {
  const response = await apiClient.get('/billing/invoices/export-dbf', {
    params: filters,
    responseType: 'blob',
    withCredentials: true,
  });
  return response.data;
};

const getPreview = async (payload) => {
  const response = await apiClient.post('/billing/invoice/preview', payload, {
    responseType: 'arraybuffer',
    withCredentials: true,
  });
  return response.data;
};

const makeInvoice = async (payload) => {
  const response = await apiClient.post('/billing/invoice/create', payload, {
    withCredentials: true,
  });
  return response.data;
};

const markAsPaid = (id, data) => {
  return apiClient
    .put(`/billing/invoices/${id}/mark-as-paid`, data)
    .then((res) => res.data);
};

export default {
  billMultiple,
  billSingle,
  cancellInvoice,
  exportExcel,
  exportConcar,
  exportDbf,
  getPreview,
  makeInvoice,
  markAsPaid,
};
